import { CookiePopup } from './ByContentType';
import usePopup from './usePopup';

import styles from './NonBlockingPopup.module.scss';

const NonBlockingPopup = () => {
  const { popup, isPopupVisible, closePopup } = usePopup('non-blocking');
  const shouldRender = isPopupVisible && popup;

  return shouldRender ? (
    <>
      {popup.contentType === 'cookie' && <CookiePopup />}
      {!popup?.contentType && popup.content && (
        <div className={styles['non-blocking-modal']}>
          <div>{popup.content}</div>
          <button type="button" onClick={closePopup}>
            Close
          </button>
        </div>
      )}
    </>
  ) : null;
};

export default NonBlockingPopup;
